module.exports = __webpack_public_path__ + "img/history.8f582b08.png";